import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Card       from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Divider    from '@material-ui/core/Divider'

import { Session, SessionStatus } from '../../api'
import { Communication }          from '../../redux'
import {
  SessionNotAvailable,
  SessionNotScheduled,
  SessionScheduled,
}                                 from '../molecules'

interface NextSessionAppointmentProps {
  onUpdate: (params: { id: number, date: string }) => void
  onSchedule: (params: { id: number, date: string }) => void
  onComplete: (params: { id: number, goals: string, achievements: string }) => void

  sessionUpdateCommunication?: Communication
  sessionScheduleCommunication?: Communication
  sessionCompletionCommunication?: Communication

  sessions: Session []
}

class NextSessionAppointment extends React.Component<NextSessionAppointmentProps> {
  public render () {
    const phrasing = {
      nextSessionAppointment:
        (
          <FormattedMessage
            id={'generic.nextSessionAppointment'}
            defaultMessage={'Next session appointment'}
          />
        ),
    }

    const scheduledSession = this.getScheduledSession()
    const sessionsToBeAnnounced = this.getTbaSessions()

    const content =
      scheduledSession && this.renderScheduled()
      || sessionsToBeAnnounced.length && this.renderNotScheduled()
      || this.renderNotAvailable()

    return (
      <Card>
        <CardHeader title={phrasing.nextSessionAppointment} />
        <Divider />
        {content}
      </Card>
    )
  }

  private renderScheduled = () => {
    const scheduledSession = this.getScheduledSession()

    const {
      sessionCompletionCommunication,
      sessionUpdateCommunication,
    } = this.props

    if (scheduledSession) {
      return (
        <SessionScheduled
          session={scheduledSession}
          onUpdateSubmit={this.updateSession}
          onCompletionSubmit={this.completeSession}
          sessionCompletionCommunication={sessionCompletionCommunication}
          sessionUpdateCommunication={sessionUpdateCommunication}
        />
      )
    }

    /*
     * semantically impossible scenario, but this return
     * + the typeguard above is for typescript
     * */
    return null
  }

  private renderNotAvailable = () =>
    <SessionNotAvailable />

  private renderNotScheduled = () => {
    const { sessionScheduleCommunication } = this.props

    return (
      <SessionNotScheduled
        communication={sessionScheduleCommunication}
        onScheduleSubmit={this.scheduleSession}
      />
    )
  }

  private scheduleSession = date => {
    this.props.onSchedule({
      date,
      id: (this.getTbaSessions() as Session [])[ 0 ].id,
    })
  }

  private updateSession = date => {
    this.props.onUpdate({
      date,
      id: (this.getScheduledSession() as Session).id,
    })
  }

  private completeSession = values => {
    this.props.onComplete({
      id: (this.getScheduledSession() as Session).id,
      ...values,
    })
  }

  private getScheduledSession () {
    const { sessions } = this.props

    return sessions.find(a => a.status === SessionStatus.Scheduled)
  }

  private getTbaSessions () {
    const { sessions } = this.props

    return sessions.filter(a => a.status === SessionStatus.Pending)
  }
}

export default NextSessionAppointment



// WEBPACK FOOTER //
// ./src/components/organisms/NextSessionAppointment.tsx